const FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSe_3QyrJO0C6cNm7UZwqXZM_yIgb9GIcCvSK8_dpCa8DVq8WQ/viewform';

const Hotelia2026 = () => (
  <div
    style={{
      minHeight: '100vh',
      background: '#f5f5f5',
      padding: '2rem 1rem',
      color: '#333',
      lineHeight: 1.6,
    }}
  >
    <div
      style={{
        maxWidth: 640,
        margin: '0 auto',
        background: '#fff',
        padding: '2rem',
        borderRadius: 8,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }}
    >
      <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Apply to Hotelia 2026</h1>
      <p style={{ marginBottom: '1rem', color: '#555' }}>
        Hotelia will be <strong>July 13–25</strong>. Use the official application to tell us about your project and
        space needs.
      </p>
      <p style={{ marginBottom: '1rem' }}>
        <a
          href={FORM_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            marginTop: '0.5rem',
            padding: '0.75rem 1.5rem',
            background: '#6366f1',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: 8,
            fontWeight: 600,
          }}
        >
          Open application form
        </a>
      </p>
      <p style={{ fontSize: '0.9rem', color: '#666' }}>
        The form opens in a new tab (Google Forms). You do not need a Hotelia account to apply.
      </p>
      <div
        style={{
          marginTop: '2rem',
          paddingTop: '1.5rem',
          borderTop: '1px solid #e0e0e0',
          fontSize: '0.9rem',
        }}
      >
        <a href="/" style={{ color: '#6366f1', textDecoration: 'none' }}>
          Hotelia home
        </a>
        {' · '}
        <a href="/login" style={{ color: '#6366f1', textDecoration: 'none' }}>
          Sign in
        </a>
        {' · '}
        <a href="/signup" style={{ color: '#6366f1', textDecoration: 'none' }}>
          Create account
        </a>
      </div>
    </div>
  </div>
);

export default Hotelia2026;
